export default __webpack_public_path__ + "static/media/Tiger's Straps of Grinning Skulls.3dceb857.jpg";